<template>
  <!-- 对话框 -->
  <el-dialog title="续费签约" :visible.sync="show" :before-close="closeDialog" style="width:1000px; margin: 0 auto;">



    <el-tabs v-model="activeName"  @tab-click="handleClick">

      <el-tab-pane label="按月缴费" name="first">
        <div class="form-box">
          <el-form label-width="80px">

            <el-form-item label="平台管理服务费:" label-width='120px'>

              <p>{{month_real_amount}}元</p>

            </el-form-item>

          </el-form>

          <div style="display: flex;justify-content: center">
            <el-button type="primary" @click="signingMonthSubmit">保存</el-button>
            <el-button @click="closeDialog">关闭</el-button>
          </div>

        </div>
      </el-tab-pane>



      <el-tab-pane label="按天缴费" name="second">

        <!-- 基本信息表单 -->
        <div class="form-box">
          <el-form label-width="80px">


            <el-form-item label="缴费天数:" label-width='120px'>
              <el-input v-model="submit_data.day_num" :placeholder="submit_rules.day_num.placeholder" @input="getMoney('day_num')">
              </el-input>
              <p style="margin-top: 10px;">
                <el-tag>减免金额:{{ money.discount }} 元 </el-tag>
                <el-tag style="margin-left: 10px;">每日金额:{{ money.one_price }} 元 </el-tag>
              </p>

              <p style="margin-top: 20px;">
                <el-tag type="success">
                  原价:{{ money.price }} 元 </el-tag>

                <el-tag style="margin-left: 10px;" type="success">减免后金额:{{ money.real_amount }} 元 </el-tag>
              </p>
            </el-form-item>

            <el-form-item label="平台管理服务费:" label-width='120px'>
              <el-input v-model="submit_data.real_amount" :placeholder="submit_rules.real_amount.placeholder" disabled>
              </el-input>
            </el-form-item>

            <el-form-item label="预存保险费单数:" label-width='120px'>
              <el-input v-model="dan" placeholder="请输入预存保险费单数" @input="getMoney('dan')">
              </el-input>
            </el-form-item>

            <el-form-item label="预存保险费:" label-width='120px'>
              <el-input v-model="submit_data.balance" :placeholder="submit_rules.balance.placeholder" disabled>
              </el-input>
            </el-form-item>

          </el-form>

          <div style="display: flex;justify-content: center">
            <el-button type="primary" @click="signingSubmit">保存</el-button>
            <el-button @click="closeDialog">关闭</el-button>
          </div>

        </div>


      </el-tab-pane>
    </el-tabs>


  </el-dialog>
</template>

<script>
  var _this;

  export default {
    props: {
      'isShow': Boolean,
      'data': '',
      'signing_city_code': ''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;
        _this.submit_data.driver_code = _this.data;


        _this.$post(
                '/driver/getsigningDriverMonthMoney'
        ).then(res => {

        _this.month_real_amount = res.data;

        }).catch((err) => {

        })

        console.log(_this.money);


      },

    },
    data() {
      return {

        show: false,

        activeName:'first',

        month_real_amount:'',

        dan:'0',

        // 需要钱数
        money: {
          discount:'0',
          one_price:'0',
          price:'0',
          real_amount:'0',
        },


        // 表单数据
        submit_data: {
          driver_code: '',
          day_num: '0',
          real_amount: '',
          balance:''
        },

        submit_rules: {
          day_num: {
            placeholder: '请输入增加续费签约天数',
            rules: {
              required: true,
              message: '未输入天数',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          balance: {
            placeholder: '请输入预存保险费',
            rules: {
              required: false,
              message: '预存保险费',
              regulation: 'egt_str',
              rulesData: 0
            }
          },
          real_amount: {
            placeholder: '请输入实际付款金额',
            rules: {
              required: true,
              message: '实际付款金额错误',
              regulation: 'egt',
              rulesData: 0
            }
          }
        },

      };
    },
    created() {
      _this = this;

    },
    methods: {
      // 按月缴费
      signingMonthSubmit(){
        _this.$post(
          '/driver/signingDriverMonthSubmit',{
            driver_code: _this.submit_data.driver_code,
            real_amount:_this.month_real_amount,
            type:'1'
          }
        ).then(res => {

          _this.$message.success({
            message: '续费签约成功',
            duration:1500
          });
          _this.$emit('onSubmit');
          _this.closeDialog();

        }).catch((err) => {

        })

      },

      handleClick(tab, event) {
        // console.log(tab, event);
      },

      // 关闭方法
      closeDialog() {

        _this.show = false;


          _this.submit_data = {
            driver_code: '',
            day_num: '0',
            real_amount: '',
            balance:''
          };


        for (const key in _this.money) {
          _this.money[key]='0';
        }



        _this.dan='0';


      },

      // 提交按钮
      signingSubmit() {
        console.log(_this.submit_data);

        _this.$post(
            '/driver/signingDriverSubmit',
            _this.submit_data,
            _this.submit_rules
          )
          .then(res => {

            _this.$message.success({
						message: '续费签约成功',
						duration:1500
					});
            _this.$emit('onSubmit');
            _this.closeDialog();

          }).catch((err) => {

          })

      },

      // 获取钱数，在输入天数时触发
      getMoney(val) {

        if(val == 'day_num'){

          if (_this.submit_data.day_num != '' && _this.submit_data.day_num != null) {
            _this.$post(
                '/driver/getSigningDriverAmount', {
                  day_num: _this.submit_data.day_num,
                  dan:_this.dan
                }
            ).then(res => {

              _this.money.discount = res.data.preferential_price;
              _this.money.one_price = res.data.one_price;
              _this.money.price = res.data.price;
              _this.money.real_amount = res.data.final_preferential_price;

              _this.submit_data.real_amount = res.data.final_preferential_price;

            }).catch((err) => {

            })
          }

        }else if(val == 'dan'){
          if (_this.dan != '' && _this.dan != null) {
            _this.$post(
                '/driver/getSigningDriverAmount', {
                  day_num: _this.submit_data.day_num,
                  dan: _this.dan
                }
            ).then(res => {

              _this.submit_data.balance = res.data.insurance_money;

            }).catch((err) => {

            })
          }
        }


      }
    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }
</style>